/**
 * World Cup 2026 Theme - Pub/Sub Pattern
 * For cart and product updates
 */

window.theme = window.theme || {};

window.theme.PubSub = (function() {
  const events = {};

  function subscribe(event, callback) {
    if (!events[event]) {
      events[event] = [];
    }
    events[event].push(callback);
    
    // Return unsubscribe function
    return function() {
      const index = events[event].indexOf(callback);
      if (index > -1) {
        events[event].splice(index, 1);
      }
    };
  }

  function publish(event, data) {
    if (events[event]) {
      events[event].forEach(function(callback) {
        callback(data);
      });
    }
  }

  return {
    subscribe: subscribe,
    publish: publish
  };
})();

// Cart events
window.theme.CartEvents = {
  UPDATED: 'cart:updated',
  ITEM_ADDED: 'cart:item_added',
  ITEM_REMOVED: 'cart:item_removed',
  QUANTITY_CHANGED: 'cart:quantity_changed'
};